import ClientBookedItems from "./ClientBookedItems";
const ViewBookedItems = () => (<ClientBookedItems cancelButtonFlag={true} />);

export default ViewBookedItems;